
/* 
 * inview & mouseover
 */
var inView = require("../libraries/in-view.min.js");

function isHover(argument) {
	$(argument).addClass('-is-hover')
			.removeClass('-is-out')
}
function isOut(argument) {
	$(argument).addClass('-is-out')
			.removeClass('-is-hover')
}

inView.threshold(0.8);
inView('.image-square')
    .on('enter', isHover)
    .on('exit', isOut);


$('.image-square')
	.on('mouseenter', function(event) {
		$(this)
			.addClass('-is-hover')
			.removeClass('-is-out')
	})
	// .on('mouseleave', function(event) {
	// 	$(this)
	// 		.addClass('-is-out')
	// 		.removeClass('-is-hover')
	// });

// $('.image-square').addClass('-is-hover')




/* 
 * product variations 
 */
var variations = function() {
	$('.-image-square-variations').each(function(index, el) {
		var index_before = $('.variations li.active', that).attr('data-index');
		var that = $(el)
		var icons = $('.variations li', that)
		var images = $('.img_hover img', that)	
		var sel_text = $('.variations .text', that)
		var sel_btn  = $('.btn', that)
		


		var changeImage = function(argument) {
			var index = $(argument).attr('data-index')
			var text = $(argument).attr('data-text')
			
			images.removeClass('active')
			images.filter( ".index_"+index ).addClass('active')

			sel_text.html( text )
			
			// console.log( "index_before: " + index_before )
		}

		var changeActive = function(argument) {
			index_before = $(argument).attr('data-index')

			icons.removeClass('active')
			$(argument).addClass('active')
			
			// console.log( $(argument).attr('data-index') )
			// console.log( "index_before: " + index_before )
		}

		var changeBtnUrl = function(argument) {
			$('.btn', that).attr('href', $(argument).attr('data-url') )
			
			// console.log( $(argument).attr('data-url') )
		}





		var on_mouseenter = function() {
			changeImage( this )
		}
		var on_mouseleave = function() {
			changeImage( that.find('ul li[data-index="'+index_before+'"]') )
		}
		var on_click = function() {
			changeActive( this )
			changeBtnUrl( this )
		}
	
		
		that.find('ul').on('mouseenter', 'li', on_mouseenter );
		that.find('ul').on('mouseleave', 'li', on_mouseleave );
		that.find('ul').on('click', 'li', on_click );

	});
}();



//////////////////
// WEBPACK FOOTER
// ./chunk/products.js
// module id = 12
// module chunks = 0